/**
 * Icon Compatibility Layer
 * Maps @tabler/icons-react to lucide-react equivalents
 * This allows gradual migration while maintaining backward compatibility
 */
import {
  Check,
  Sparkles,
  Users,
  Briefcase,
  X,
  Plus,
  Star,
  Rocket,
  Search,
  Code,
  ShieldCheck,
  FileText,
  Clock,
  ArrowRight,
  ArrowDown,
  Loader2,
  Brain,
  TrendingUp,
  Video,
  VideoOff,
  Globe,
  Settings,
  ChevronRight,
  ChevronLeft,
  BarChart2,
  AlertCircle,
  Target,
  Send,
  MapPin,
  DollarSign,
  User,
  RefreshCw,
  Image,
  ChevronDown,
  ChevronUp,
  ArrowLeft,
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Calendar,
  CalendarDays,
  Mail,
  Phone,
  PhoneOff,
  MessageSquare,
  MessageCircle,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Trash2,
  Edit,
  Pencil,
  Copy,
  Download,
  Upload,
  ExternalLink,
  Link,
  Home,
  Menu,
  Filter,
  Bookmark,
  Award,
  Zap,
  Shield,
  CheckCircle,
  XCircle,
  Info,
  HelpCircle,
  AlertTriangle,
  Play,
  Pause,
  Circle,
  Volume2,
  Maximize,
  Minimize,
  MoreHorizontal,
  MoreVertical,
  Grid,
  List,
  Folder,
  File,
  Layers,
  Activity,
  PieChart,
  LineChart,
  Headphones,
  Mic,
  MicOff,
  Camera,
  Palette,
  Lightbulb,
  Flag,
  Bell,
  BellOff,
  Package,
  CreditCard,
  Wallet,
  Receipt,
  Building2,
  Building,
  GraduationCap,
  Newspaper,
  Percent,
  Gift,
  Scale,
  Gauge,
  Compass,
  Navigation,
  Crosshair,
  Inbox,
  Archive,
  Hash,
  Pin,
  PinOff,
  Paperclip,
  Share2,
  ShoppingCart,
  Megaphone,
  Tags,
  Tag,
  LayoutTemplate,
  Wrench,
  Trophy,
  UsersRound,
  Wand2,
  Server,
  Database,
  Laptop,
  Smartphone,
  BarChart3,
  Calculator,
  BadgeCheck,
  Crown,
  Presentation,
  ScreenShare,
  ScreenShareOff,
  Smile,
  Languages,
  Github,
  Linkedin,
  Twitter,
  Facebook,
  CheckCheck,
  CircleDot
} from 'lucide-react';

// Icon name mappings (Tabler name -> Lucide export)
export const IconCheck = Check;
export const IconSparkles = Sparkles;
export const IconUsers = Users;
export const IconBriefcase = Briefcase;
export const IconX = X;
export const IconPlus = Plus;
export const IconStar = Star;
export const IconStarFilled = Star;
export const IconRocket = Rocket;
export const IconSearch = Search;
export const IconCode = Code;
export const IconShieldCheck = ShieldCheck;
export const IconFileText = FileText;
export const IconClock = Clock;
export const IconArrowRight = ArrowRight;
export const IconLoader2 = Loader2;
export const IconLoader = Loader2;
export const IconBrain = Brain;
export const IconTrendingUp = TrendingUp;
export const IconVideo = Video;
export const IconWorld = Globe;
export const IconGlobe = Globe;
export const IconSettings = Settings;
export const IconChevronRight = ChevronRight;
export const IconChevronDown = ChevronDown;
export const IconChevronUp = ChevronUp;
export const IconChartBar = BarChart2;
export const IconAlertCircle = AlertCircle;
export const IconTarget = Target;
export const IconSend = Send;
export const IconMapPin = MapPin;
export const IconCurrencyDollar = DollarSign;
export const IconCurrency = DollarSign;
export const IconUser = User;
export const IconRefresh = RefreshCw;
export const IconPhoto = Image;
export const IconArrowLeft = ArrowLeft;
export const IconEye = Eye;
export const IconEyeOff = EyeOff;
export const IconLock = Lock;
export const IconUnlock = Unlock;
export const IconCalendar = Calendar;
export const IconMail = Mail;
export const IconPhone = Phone;
export const IconMessage = MessageSquare;
export const IconMessageSquare = MessageSquare;
export const IconHeart = Heart;
export const IconHeartFilled = Heart;
export const IconThumbUp = ThumbsUp;
export const IconThumbDown = ThumbsDown;
export const IconTrash = Trash2;
export const IconEdit = Edit;
export const IconCopy = Copy;
export const IconDownload = Download;
export const IconUpload = Upload;
export const IconExternalLink = ExternalLink;
export const IconLink = Link;
export const IconHome = Home;
export const IconMenu = Menu;
export const IconFilter = Filter;
export const IconBookmark = Bookmark;
export const IconAward = Award;
export const IconBolt = Zap;
export const IconZap = Zap;
export const IconShield = Shield;
export const IconCircleCheck = CheckCircle;
export const IconCircleX = XCircle;
export const IconInfoCircle = Info;
export const IconInfo = Info;
export const IconHelp = HelpCircle;
export const IconAlertTriangle = AlertTriangle;
export const IconPlayerPlay = Play;
export const IconPlayerPause = Pause;
export const IconVolume = Volume2;
export const IconMaximize = Maximize;
export const IconMinimize = Minimize;
export const IconDots = MoreHorizontal;
export const IconDotsVertical = MoreVertical;
export const IconLayoutGrid = Grid;
export const IconList = List;
export const IconFolder = Folder;
export const IconFile = File;
export const IconLayers = Layers;
export const IconActivity = Activity;
export const IconChartPie = PieChart;
export const IconChartLine = LineChart;
export const IconHeadphones = Headphones;
export const IconMicrophone = Mic;
export const IconCamera = Camera;
export const IconPalette = Palette;
export const IconBulb = Lightbulb;
export const IconLightbulb = Lightbulb;
export const IconFlag = Flag;
export const IconBell = Bell;
export const IconPackage = Package;
export const IconCreditCard = CreditCard;
export const IconWallet = Wallet;
export const IconReceipt = Receipt;
export const IconBuilding = Building2;
export const IconSchool = GraduationCap;
export const IconNews = Newspaper;
export const IconPercentage = Percent;
export const IconGift = Gift;
export const IconScale = Scale;
export const IconGauge = Gauge;
export const IconCompass = Compass;
export const IconNavigation = Navigation;
export const IconFocus = Crosshair;
export const IconUserCheck = CheckCircle;
export const IconUserPlus = Plus;
export const IconAdjustments = Settings;
export const IconGitCompare = Scale;

// Additional icons
export const IconInbox = Inbox;
export const IconArchive = Archive;
export const IconArrowDown = ArrowDown;
export const IconBadge = BadgeCheck;
export const IconBellOff = BellOff;
export const IconBrandAws = Server;
export const IconBrandFacebook = Facebook;
export const IconBrandGithub = Github;
export const IconBrandLinkedin = Linkedin;
export const IconBrandPython = Code;
export const IconBrandReact = Code;
export const IconBrandTwitter = Twitter;
export const IconBuildingSkyscraper = Building;
export const IconCalculator = Calculator;
export const IconCalendarEvent = CalendarDays;
export const IconCategory = Grid;
export const IconCertificate = Award;
export const IconChecks = CheckCheck;
export const IconChevronLeft = ChevronLeft;
export const IconCircleFilled = CircleDot;
export const IconCrown = Crown;
export const IconDatabase = Database;
export const IconDeviceAnalytics = BarChart3;
export const IconDeviceLaptop = Laptop;
export const IconDeviceMobile = Smartphone;
export const IconHash = Hash;
export const IconHeadset = Headphones;
export const IconLanguage = Languages;
export const IconMessageCircle = MessageCircle;
export const IconMicrophoneOff = MicOff;
export const IconMoodSmile = Smile;
export const IconPaperclip = Paperclip;
export const IconPencil = Pencil;
export const IconPhoneOff = PhoneOff;
export const IconPin = Pin;
export const IconPinFilled = Pin;
export const IconPlayerRecord = Circle;
export const IconPresentation = Presentation;
export const IconRecordMail = Mail;
export const IconRosetteDiscountCheck = BadgeCheck;
export const IconScreenShare = ScreenShare;
export const IconScreenShareOff = ScreenShareOff;
export const IconServer = Server;
export const IconShare = Share2;
export const IconShoppingCart = ShoppingCart;
export const IconSpeakerphone = Megaphone;
export const IconTags = Tags;
export const IconTemplate = LayoutTemplate;
export const IconTool = Wrench;
export const IconTrophy = Trophy;
export const IconUsersGroup = UsersRound;
export const IconVideoOff = VideoOff;
export const IconWand = Wand2;
export const IconApi = Server;
export const IconBook = FileText;
export const IconMinus = X;
export const IconGripVertical = MoreVertical;

// Default export with all icons
export default {
  Check: IconCheck,
  Sparkles: IconSparkles,
  Users: IconUsers,
  Briefcase: IconBriefcase,
  X: IconX,
  Plus: IconPlus,
  Star: IconStar,
  Rocket: IconRocket,
  Search: IconSearch,
  Code: IconCode,
  ShieldCheck: IconShieldCheck,
  FileText: IconFileText,
  Clock: IconClock,
  ArrowRight: IconArrowRight,
  Loader2: IconLoader2,
  Brain: IconBrain,
  TrendingUp: IconTrendingUp,
  Video: IconVideo,
  Globe: IconWorld,
  Settings: IconSettings,
  ChevronRight: IconChevronRight,
  BarChart2: IconChartBar,
  AlertCircle: IconAlertCircle,
  Target: IconTarget,
  Send: IconSend,
  MapPin: IconMapPin,
  DollarSign: IconCurrencyDollar,
  User: IconUser,
  RefreshCw: IconRefresh,
  Image: IconPhoto
};
